import React from 'react'
import Swiper from "swiper/bundle";
import Icons from '../../myIcon/Icons';

export default function HomeTestimonial({data}) {
  const swiperRef = React.useRef(null);

  const swiperInstance = React.useRef(null);

React.useEffect(() => {
  if (swiperRef.current) {

    // destroy previous instance (prevents duplicate + glitch)
    if (swiperInstance.current) {
      swiperInstance.current.destroy(true, true);
    }

    swiperInstance.current = new Swiper(swiperRef.current, {
      grabCursor: false,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      loopedSlides: 2,
      watchSlidesProgress: true,

      slidesPerView: "auto",
      allowTouchMove: false,
      simulateTouch: false,

      navigation: {
        nextEl: ".arrow-right",
        prevEl: ".arrow-left",
      },

      keyboard: { enabled: true },
      speed: 1500,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 150,
        modifier: 2.5,
        slideShadows: false,
      },

      // 🔥 fix rapid click / reverse glitch
      on: {
        slideChangeTransitionStart: function () {
          this.allowSlideNext = false;
          this.allowSlidePrev = false;
        },
        slideChangeTransitionEnd: function () {
          this.allowSlideNext = true;
          this.allowSlidePrev = true;
        },
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 30,
          coverflowEffect: {
            stretch: 0,
            depth: 0,
          },
        },
        800: {
          slidesPerView: 2,
          spaceBetween: 30,
          coverflowEffect: {
            stretch: 0,
            depth: 0,
          },
        },
        1025: {
          slidesPerView: 2,
          spaceBetween: 0
        },
      },
    });
  }

  // cleanup on unmount
  return () => {
    if (swiperInstance.current) {
      swiperInstance.current.destroy(true, true);
    }
  };

}, []);

  return (
    <>
      <section className="location-client" id="testimonials">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="gift-content heading-center">
              <h3 className="heading center-heading">{data?.title}</h3>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="swiper" ref={swiperRef}>
              <div className="swiper-wrapper">
                {data.slides.map((item, index) => (
                  <div className="swiper-slide" key={index}>
                    <span>{item?.title}</span>
                    <p>{item?.desc}</p>
                    <div>
                      <img src={item?.image} alt="User" loading='lazy'/>
                      <div>
                        <label>{item?.name}</label>
                        <small>{item?.designation}</small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* arrows */}
            <div id="clients" className="testimonial-arrows">
              <div className="arrow arrow-left">
                <Icons name="Longarrow_left"/>
              </div>
              <div className="arrow arrow-right">
                <Icons name="Longarrow_right"/>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}
